<div
	*ngIf="editMode"
	class="overlay bg-black opacity-30 fixed top-0 left-0 w-screen h-screen z-30"
></div>
<div>
	<div class="flex flex-row justify-between mt-4 min-h-[40px]">
		<p class="text-dark-grey font-medium text-base leading-5 m-0">
			{{ 'STORE.STORE_PROFILE.STORE_INFORMATION' | translate }}
		</p>
		<div
			(click)="editMode = !editMode"
			*ngIf="!editMode"
			class="flex gap-1 ltr:mr-6 rtl:ml-6 hover:cursor-pointer"
		>
			<img class="w-5 max-h-5" src="assets/images/edit-blue.svg" alt="" />
			<p class="text-link">
				{{ 'ACTIONS.EDIT' | translate }}
			</p>
		</div>
	</div>
</div>
<div
	class="custom-shadow rounded-12px py-12px px-24px custom-accordion {{
		editMode ? 'z-40' : ''
	}} relative bg-off-white"
>
	<ng-container>
		<form [formGroup]="storeInfoForm">
			<div class="pt-8px flex justify-between">
				<p
					class="text-medium-gray text-font-16 ltr:mr-[16px] rtl:ml-[16px] mb-[8px]"
				>
					{{ 'STORE.STORE_PROFILE.PHYSICAL_STORE' | translate }}
				</p>
				<mat-slide-toggle
					(change)="changePhysicalStore($event)"
					[disabled]="!editMode"
					class="ltr:mr-[8px] rtl:ml-[8px]"
					formControlName="physicalStore"
				></mat-slide-toggle>
			</div>
			<div class="h-[1px] w-full bg-secondry-color-Gray my-[10px]"></div>
			<div
				*ngIf="!this.getController('physicalStore')?.value && editMode"
				class="pt-8px flex justify-between"
			>
				<p
					class="text-medium-gray text-font-16 ltr:mr-[16px] rtl:ml-[16px] mb-[8px]"
				>
					{{ 'STORE.STORE_PROFILE.PLAN_TO_HAVE_PHYSICAL_STORE' | translate }}
				</p>
				<mat-checkbox
					formControlName="expectedToHaveStore"
					(change)="expectedToHaveStore($event)"
					[disabled]="!editMode"
				></mat-checkbox>
			</div>

			<div
				*ngIf="this.getController('physicalStore')?.value"
				class="pt-8px flex justify-between"
			>
				<p
					class="text-medium-gray text-font-16 ltr:mr-[16px] rtl:ml-[16px] mb-[8px]"
				>
					{{ 'STORE.STORE_PROFILE.HAVE_STORE_BRANCHES' | translate }}
				</p>
				<mat-checkbox
					formControlName="storeBranches"
					(change)="storeBranchesChange($event)"
					[disabled]="!editMode"
				></mat-checkbox>
			</div>
			<div
				*ngIf="this.getController('physicalStore')?.value"
				class="h-[1px] w-full bg-secondry-color-Gray my-[10px]"
			></div>
			<ng-container
				class="pt-8px"
				*ngIf="this.getController('storeBranches')?.value"
			>
				<div *ngIf="editMode" class="flex justify-between">
					<p class="mb-0">
						{{ 'STORE.STORE_PROFILE.NUMBER_BRANCHES' | translate }}
					</p>

					<div
						class="flex rounded-[8px] bg-input-background text-dark-grey px-[14px] py-[5px]"
					>
						<button (mouseup)="changeBranchCount('-')">-</button>
						<span class="text-dark-grey mx-[14px]">{{
							this.getController('storeBranchesCount')?.value
						}}</span>
						<button (mouseup)="changeBranchCount('+')" class="text-dark-grey">
							+
						</button>
					</div>
				</div>
				<div *ngIf="!editMode">
					<p
						class="text-dark-grey text-font-12 font-Poppins-semi-bold ltr:mr-[16px] rtl:ml-[16px] mb-0"
					>
						{{ 'STORE.STORE_PROFILE.NUMBER_BRANCHES' | translate }}
					</p>
					<p class="text-medium-gray text-font-16 mb-0">
						{{ this.getController('storeBranchesCount')?.value }}
					</p>
				</div>
			</ng-container>
			<div
				*ngIf="this.getController('storeBranches')?.value"
				class="h-[1px] w-full bg-secondry-color-Gray my-[10px]"
			></div>
			<div class="pt-8px" *ngIf="this.getController('physicalStore')?.value">
				<p
					*ngIf="!editMode"
					class="text-dark-grey text-font-12 font-Poppins-semi-bold ltr:mr-[16px] rtl:ml-[16px] mb-0"
				>
					{{ 'STORE.STORE_PROFILE.COMMERCIAL_REGISTRATION' | translate }}
				</p>

				<mat-form-field
					*ngIf="editMode"
					class="w-full mr-8px mb-[30px]"
					appearance="outline"
				>
					<mat-label>{{
						'ORGANIZATION.ORGANIZATION_STATUS.COMMERCIAL_REGISTRATION'
							| translate
					}}</mat-label>
					<input
						maxlength="20"
						type="text"
						(keydown)="isNumber($event)"
						formControlName="commercialRegister"
						matInput
					/>

					<mat-error>
						<validation-message
							[controller]="getController('commercialRegister')"
							controller_name="STORE.STORE_PROFILE.COMMERCIAL_REGISTRATION"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
				<p *ngIf="!editMode" class="text-medium-gray text-font-16 mb-0">
					{{ getController('commercialRegister')?.value }}
				</p>
			</div>
			<div class="flex justify-end gap-3">
				<!-- cancel button  -->
				<button
					*ngIf="editMode"
					(click)="editMode = !editMode; cancel()"
					class="border border-solid border-[#D9DBE9] hover:bg-gradient hover:text-off-white mx-2"
					mat-button
				>
					{{ 'ACTIONS.CANCEL' | translate }}
				</button>
				<!-- submit button  -->
				<button
					[disabled]="this.storeInfoForm.invalid"
					*ngIf="editMode"
					(click)="editMode = !editMode; submit()"
					class="bg-gradient text-white"
					mat-button
				>
					{{ 'ACTIONS.SAVE' | translate }}
				</button>
			</div>
		</form>
	</ng-container>
</div>
